import { render, staticRenderFns } from "./resourceStatic.vue?vue&type=template&id=186a27f4&scoped=true&"
import script from "./resourceStatic.vue?vue&type=script&lang=js&"
export * from "./resourceStatic.vue?vue&type=script&lang=js&"
import style0 from "./resourceStatic.vue?vue&type=style&index=0&id=186a27f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a27f4",
  null
  
)

export default component.exports